<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Client Department Details</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="sm" variant="warning" @click="goToMain"
                >Add Dept</b-button
              >
            </b-nav-form>

            <b-button
              size="sm"
              class="ml-2"
              :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
              @click="viewClientDetail('Excel')"
              variant="outline-info"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export as Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
          </b-navbar-nav>
        </b-navbar>
        <div>
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small>{{ totalRows }} Entries</small>
          </h5>
        </div>
        <div>
          <b-form-group>
            <b-input-group>
              <b-form-input
                :formatter="capitalizeAll"
                v-model="filter"
                placeholder="Type To Search"
              />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="table-responsive tableMain">
          <b-table
            show-empty
            stacked="md"
            :items="clientListView"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template slot="clientId" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="clientName" slot-scope="row11">
              <div
                :style="row11.item.isKYC != 'Yes' ? 'color:red' : ''"
                @click="updateClientDept(row11.item.clientId)"
                class="showMoreData"
              >
                <span>{{ row11.item.clientName }}</span>
                <br />
                <h6>
                  <b-badge v-if="row11.item.isKYC != 'Yes'" variant="danger"
                    >Kyc Not Done</b-badge
                  >
                </h6>
              </div>
            </template>
            <template slot="phoneKYC" slot-scope="row1">
              <span>Contact No. : {{ row1.item.phoneKYC }}</span>
              <br />
              <span>Email-Address : {{ row1.item.email }}</span>
              <br />
              <span>Alternate Email-Addr : {{ row1.item.altMail }}</span>
              <br />
              <span>
                Corporate Address : {{ row1.item.corporateAddress }}
                <br />
                {{ row1.item.stateName }}
              </span>
            </template>

            <template slot="status" slot-scope="row3">
              <b-button
                variant="outline-danger"
                size="sm"
                @click="updateClientDept(row3.item.clientId)"
              >
                {{
                  row3.item.dept_type && row3.item.dept_type != ""
                    ? "Completed"
                    : "Pending"
                }}
              </b-button>
            </template>

            <template slot="clientIsActive" slot-scope="row3">
              <b-button
                variant="outline-danger"
                size="sm"
                @click="deleteClientDept(row3.item.clientId)"
              >
                <md-icon>delete_sweep</md-icon>
              </b-button>
            </template>
          </b-table>
        </div>

        <div>
          <b-pagination
            limit="5"
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import DatePicker from "vue2-datepicker";

import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      if (globalPermissionStatus("addClient") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("addClient")
        );
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      this.$store.dispatch("setCurrentRoute", "/client/viewClient");

      this.viewClientDetail("Normal");
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },

  data() {
    return {
      ExcelBtnName: "Export as Excel",
      fields: [
        {
          key: "clientId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "phoneKYC",
          label: "Contact Detail",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "department",
          label: "Deparment Detail",
          sortDirection: "desc",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "clientIsActive",
          label: "Delete",
          sortable: true,
          sortDirection: "desc",
          class: "text-center",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      clientId: "",
      clientListView: [],
      excelUpload: "",
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    ModelListSelect,
    // Loading,
    CustomLoader,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$sessionsStorage.set("editClientId", "");
      this.$sessionsStorage.set("editClientType", "");

      this.$router.push({
        path: "/client/addClientDept",
      });
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    JqueryFun() {
      return $(function () {
        return $("#viewSalesBooking").DataTable();
      });
    },

    onClose(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "clientdetail",
          tableIsActive: "clientIsActive",
          tableId: "clientId",
          tableVal: this.clientId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.viewClientDetail("Normal");

              // console.log(data);
            }
          })
          .catch((error) => {});
      } else {
        this.viewClientDetail("Normal");
      }
    },

    deleteClient(clientID) {
      this.clientId = clientID;
      this.$refs["addPop"].open();
    },

    deleteClientDept(clientID) {
      this.clientId = clientID;
      //   this.$refs["addPop"].open();
      console.log(clientID);
    },

    updateClientDept(clientID) {
      this.clientId = clientID;
      //   this.$refs["addPop"].open();
      console.log(clientID);
      this.$router.push({
        path: "/client/addClientDept",
        query: {
          clientId: clientID,
        },
      });
    },

    viewClientpage(clientID) {
      this.$sessionsStorage.set("editClientId", clientID);
      this.$router.push({
        path: "/client/addClient",
      });
    },

    viewClientDetail(type) {
      this.doLoading();
      let client_detail = {
        onlyClientview: "view",
        type: type,
      };

      if (type == "Excel") {
        this.ExcelBtnName = "Downloading....";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewClientDeptDetails.php`,
        data: JSON.stringify(client_detail),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (data.clientId != "" && status == 200 && data) {
            this.JqueryFun();

            this.clientListView = data.allclient1;
            this.totalRows = data.allclient1.length;
            this.doLoadingClose();
            console.log(data);
          }

          if (type == "Excel") {
            if (data.allclient1.length > 0) {
              this.clientListView = data.allclient1;
              this.totalRows = data.allclient1.length;
              this.ExcelBtnName = "Export as Excel";
            }
            window.location.href =
              `https://uploadsp.pridel.com/Pridel_Reports/` +
              data.excelName;
          } else {
            if (data.allclient1.length > 0) {
              this.clientListView = data.allclient1;
              this.totalRows = data.allclient1.length;
              console.log("Client Dept List response=>", data);
            }
          }
        })
        .catch((error) => {});
    },
    downloadExcel() {
      let excelName = {
        excelName: "ClientMaster",
        validExcel: "yes",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/downloadMasterExcel.php`,
        data: JSON.stringify(excelName),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // console.log(data);
            // console.log(data.link12);

            window.open(data.link12);
          }
        })
        .catch((error) => {});
    },

    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`clientMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then((result) => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.viewClientDetail("Normal");
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// viewClientDept.vue?f3bbc7ca